import { apiClient } from '../../../api/client'
import type {
  FlightRecord,
  FlightRecordPage,
  FlightRecordQuery,
  FlightRecordUpsert,
  MeetingRecord,
  MeetingRecordPage,
  MeetingRecordQuery,
  MeetingRecordUpsert,
  TimePortfolioLookups,
} from '../types'

const MEETINGS = '/management/gm-meeting-records'
const FLIGHTS = '/management/gm-flight-records'

/**
 * Boş süzgeçleri istekten **düşürür**. Sunucu `null` ile "filtre yok" demiyor, parametrenin
 * **yokluğuyla** diyor; boş dizgi gönderilirse `q` dolu sayılır ve hiçbir kayıt eşleşmez.
 */
function params(source: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(source).filter(([, v]) => v !== null && v !== undefined && v !== ''),
  )
}

/** Toplantı kayıtları — sunucu tarafı sayfalama ve süzme (en yeni kayıt üstte). */
export async function getMeetingRecords(query: MeetingRecordQuery): Promise<MeetingRecordPage> {
  const { data } = await apiClient.get<MeetingRecordPage>(MEETINGS, { params: params({ ...query }) })
  return data
}

/** Formun iki açılır listesi (Kayıt Türü · Kategori) — tek istekte. */
export async function getTimePortfolioLookups(): Promise<TimePortfolioLookups> {
  const { data } = await apiClient.get<TimePortfolioLookups>(`${MEETINGS}/lookups`)
  return data
}

export async function createMeetingRecord(body: MeetingRecordUpsert): Promise<MeetingRecord> {
  const { data } = await apiClient.post<MeetingRecord>(MEETINGS, body)
  return data
}

export async function updateMeetingRecord(
  id: number,
  body: MeetingRecordUpsert,
): Promise<MeetingRecord> {
  const { data } = await apiClient.put<MeetingRecord>(`${MEETINGS}/${id}`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteMeetingRecord(id: number): Promise<void> {
  await apiClient.delete(`${MEETINGS}/${id}`)
}

/** Uçuş kayıtları — aynı sayfalama/süzme kalıbı, daha az alan. */
export async function getFlightRecords(query: FlightRecordQuery): Promise<FlightRecordPage> {
  const { data } = await apiClient.get<FlightRecordPage>(FLIGHTS, { params: params({ ...query }) })
  return data
}

export async function createFlightRecord(body: FlightRecordUpsert): Promise<FlightRecord> {
  const { data } = await apiClient.post<FlightRecord>(FLIGHTS, body)
  return data
}

export async function updateFlightRecord(
  id: number,
  body: FlightRecordUpsert,
): Promise<FlightRecord> {
  const { data } = await apiClient.put<FlightRecord>(`${FLIGHTS}/${id}`, body)
  return data
}

export async function deleteFlightRecord(id: number): Promise<void> {
  await apiClient.delete(`${FLIGHTS}/${id}`)
}
